export interface SheetViewport {
  /** Клавиатура открыта: окно прижимаем к видимой области и убираем всё лишнее. */
  keyboard: boolean;
  /** Низкий экран без клавиатуры: шапку делаем компактнее, чтобы влез результат. */
  short: boolean;
}

const KEYBOARD_MIN_HEIGHT = 150;
const SHORT_SCREEN_HEIGHT = 620;

/**
 * Следит за видимой областью, пока открыт выбор адреса.
 *
 * Одной разницы `innerHeight − visualViewport.height` мало: Safari и Chrome под
 * клавиатуру сжимают только видимую область, а браузеры внутри приложений и
 * Firefox — ещё и само окно, и тогда обе высоты уменьшаются вместе. Поэтому
 * помним самую большую высоту, которую видели при этой ширине.
 */
export function createSheetViewportTracker() {
  let fullHeight = 0;
  let lastWidth = 0;
  return (width: number, height: number, innerHeight: number): SheetViewport => {
    // Экран повернули — прежняя высота больше ничего не значит.
    if (width !== lastWidth) {
      lastWidth = width;
      fullHeight = height;
    } else fullHeight = Math.max(fullHeight, height);
    const keyboard = Math.max(innerHeight, fullHeight) - height > KEYBOARD_MIN_HEIGHT;
    return { keyboard, short: !keyboard && height < SHORT_SCREEN_HEIGHT };
  };
}
